import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".LorryNumber-module_main__HwoTZ {\n  letter-spacing: 1px;\n}\n\n.LorryNumber-module_masked__XwKpU {\n  font-size: 1.5em;\n  vertical-align: -webkit-baseline-middle;\n}";
var Styles = {"main":"LorryNumber-module_main__HwoTZ","masked":"LorryNumber-module_masked__XwKpU"};
styleInject(css_248z);

export { Styles as default };
//# sourceMappingURL=LorryNumber.module.scss.js.map
